import styled from "styled-components";

export const Card = styled.div<{
  $color: string | undefined;
  $hidden: boolean;
}>`
  display: flex;
  flex-direction: column;
  max-width: 350px;
  min-width: 150px;
  width: 100%;
  // box-sizing: border-box;
  color: ${({ theme }) => theme.colors.textSecondary};
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background: ${({ theme }) => theme.colors.menuBackground};
  padding: 5px 10px;
  transition: 0.3s ease-out;
  opacity: ${({ $hidden }) => ($hidden ? 0.45 : 1)};

  &:hover {
    background: ${({ $color, theme }) => {
      if (!$color) return theme.colors.treeNodeHover;
      const hex = $color.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, 0.15)`;
    }};
    cursor: pointer;
  }

  @media screen and (max-width: 520px) {
    max-width: 100%;
  }
`;

export const Line = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${({ theme }) => theme.spacing.small};

  @media screen and (max-width: 1520px) {
    gap: 7px;
  }
`;

export const Indicator = styled.span<{ $color: string | undefined }>`
  width: 0.85rem;
  height: 0.85rem;
  border-radius: 999px;
  background: ${({ $color, theme }) => $color ?? theme.colors.mediumGrey};

  @media screen and (max-width: 1520px) {
    width: 0.75rem;
    height: 0.75rem;
  }
`;

export const Name = styled.p`
  font-weight: 500;
  padding: 0;
  margin: 0;
  font-size: 0.85rem;

  @media screen and (max-width: 1520px) {
    font-size: 0.75rem;
  }
`;

export const Value = styled.p<{ $color: string | undefined }>`
  font-weight: 600;
  font-size: 1.25rem;
  padding: 0;
  margin: 0;
  color: ${({ $color }) => $color};
  min-width: 40px;
  line-height: 1.25rem;

  @media screen and (max-width: 1520px) {
    font-size: 1.1rem;
  }
`;

export const Units = styled.p<{ $color: string | undefined }>`
  font-weight: 600;
  padding: 0;
  margin: 0;
  color: ${({ $color }) => $color};
  font-size: 0.9rem;
  white-space: nowrap;

  @media screen and (max-width: 1520px) {
    font-size: 0.85rem;
  }
`;
